<div class="container">
  <div class="row">
    <div class="col-md-6">
      <pv-login [redirect]="redirect"></pv-login>
    </div>
    <div class="col-md-6 align-center-text">
      <h3>Welcome to the {{account.short_name}} Wholesale Store!</h3>
      <h5>Don't have an account?</h5>
      <p>Send us an email to get set up: <a href="mailto:{{account.wholesale_email}}">{{account.wholesale_email}}</a></p>
    </div>
  </div>
</div>